import ProductsCarousel from '@components/product/products-carousel'
import { LIMITS } from '@framework/utils/limits'
import { FC } from 'react'

interface RelatedProductsProps {
  carouselBreakpoint?: {} | any
  className?: string
  uniqueKey?: string
  hits: {} | any
  titleClassName?: string
  sectionHeading?: string
}

const RelatedProductFeed: FC<RelatedProductsProps> = ({
  carouselBreakpoint,
  className,
  uniqueKey = 'related-product-popup',
  hits,
  titleClassName,
  sectionHeading,
}) => {
  const isLoading = false

  return (
    <ProductsCarousel
      sectionHeading={sectionHeading || 'text-related-products'}
      categorySlug="/search"
      className={className}
      titleClassName={titleClassName}
      products={hits}
      loading={isLoading}
      // error={error?.message}
      limit={LIMITS.RELATED_PRODUCTS_LIMITS}
      uniqueKey={uniqueKey}
      carouselBreakpoint={carouselBreakpoint}
    />
  )
}

export default RelatedProductFeed
